import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { RiAdminFill } from "react-icons/ri";
import { SiGoogleanalytics } from "react-icons/si";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { IoDocumentText } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import { useAirportPickupData } from './AirportPickupDataContext';

const Navbar = ({ currentPage, setAirportPickupData }) => {
    const username = localStorage.getItem("currentuser") ?? 'Hello'; 
    const navigate = useNavigate();
    const { airportPickupData } = useAirportPickupData();

    function handleLogout() {
        navigate('/adminLogin');
        localStorage.removeItem("currentuser");
    }

    function navigateToStatistic() {
        navigate('/statistic', { state: { airportPickupData } });
    }

    return (
        <div>
            {(currentPage === 'AdminPortal' || currentPage === 'Statistic') && (
        <div className="navbar">
            <div className="navbar-header">
                {username && <p>Welcome, {username}</p>}
            </div>
            <div className="navbar-content">
                <Link to="/adminPortal">
                    <button className="nav-button"><RiAdminFill style={{ color: 'white', marginRight :'2px' }} />Admin Portal</button>
                        </Link>
                      
                        <button className="nav-button" onClick={navigateToStatistic}>
                            <SiGoogleanalytics style={{ color: 'white', marginRight: '2px' }} />Statistic
                        </button>
            </div>
            <div className="navbar-footer">
                <button className="logout-button" onClick={() => handleLogout()}>Logout<RiLogoutBoxRLine style={{ color: 'white', marginLeft: '5px' }} /></button>
            </div>
                </div>
            )}

            {currentPage === 'PickupForm' && (
                <div className="navbar">     
                    <div className="navbar-header"/>
                    <div className="navbar-content">                   
                        <Link to="/pickupForm">
                            <button className="nav-button">< IoDocumentText style={{ color: 'white', marginRight: '5px' }} />Form</button>
                        </Link>
                    </div>
                    <div className="navbar-footer"/>                 
                </div>
            )}


        </div>
    );
}

export default Navbar;
